<div class="message-text mb-2" [innerHTML]="message | async"></div>
<div class="d-flex align-items-end">
    <button mat-raised-button color="primary" (click)="dismiss()">
      {{ 'Common.Ok' | translate }}
    </button>
</div>
